import { render, staticRenderFns } from "./swipers.vue?vue&type=template&id=197790f5&scoped=true"
import script from "./swipers.vue?vue&type=script&lang=js"
export * from "./swipers.vue?vue&type=script&lang=js"
import style0 from "./swipers.vue?vue&type=style&index=0&id=197790f5&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "197790f5",
  null
  
)

export default component.exports